export default __webpack_public_path__ + "static/fonts/HelveticaNeueMedium.978dd5b.woff2";